// extracted by mini-css-extract-plugin
export default {"footer":"footer__g9J3nF"};